// Icons
import { useEffect, useRef, useState } from "react";
import { FaReact } from "react-icons/fa";
import { IoLogoJavascript } from "react-icons/io";
import { FaNodeJs } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { FaWordpress } from "react-icons/fa";
import { FaPhp } from "react-icons/fa";
import { FaHtml5 } from "react-icons/fa";
import { FaCss3 } from "react-icons/fa";
import { RiTailwindCssFill } from "react-icons/ri";
import { FaBootstrap } from "react-icons/fa";
import { SiStrapi } from "react-icons/si";
import { RiFirebaseFill } from "react-icons/ri";
import { FaCpanel } from "react-icons/fa";
import { SiHostinger } from "react-icons/si";
import { FaElementor } from "react-icons/fa";
import { RiDisqusFill } from "react-icons/ri";
import { SiMysql } from "react-icons/si";
import { FaGithub } from "react-icons/fa";

// Slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SkillsSection = [
  {
    icon: <FaReact />,
    skillTitle: <h2>ReactJS</h2>,
    smallDescription:
      "Economics is a social science concerned with the production, consumption of goods and services",
  },
  {
    icon: <FaNodeJs />,
    skillTitle: <h2>Node.js</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <IoLogoJavascript />,
    skillTitle: <h2>JavaScript</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaPython />,
    skillTitle: <h2>Python</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaWordpress />,
    skillTitle: <h2>WordPress</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaPhp />,
    skillTitle: <h2>PHP</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaHtml5 />,
    skillTitle: <h2>HTML</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaCss3 />,
    skillTitle: <h2>CSS</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <RiTailwindCssFill />,
    skillTitle: <h2>Tailwind CSS </h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaBootstrap />,
    skillTitle: <h2>Bootstrap</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <SiStrapi />,
    skillTitle: <h2>Strapi</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <RiFirebaseFill />,
    skillTitle: <h2>Firebase</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaCpanel />,
    skillTitle: <h2>cPanel</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <SiHostinger />,
    skillTitle: <h2>hPanel</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaElementor />,
    skillTitle: <h2>Elementor</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <RiDisqusFill />,
    skillTitle: <h2>Divi</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <SiMysql />,
    skillTitle: <h2>MySQL</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
  {
    icon: <FaGithub />,
    skillTitle: <h2>GitHub</h2>,
    smallDescription:
      "Node.js allows developers to build scalable backend applications quickly and efficiently",
  },
];

const Skills = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, 500);
  }, []);

  // Slider settings
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="section" id="section-skills">
      <div className="content flex justify-between items-start mb-6">
        <div className="titles">
          <div className="title text-2xl font-bold">Skills</div>
        </div>
      </div>

      <Slider {...settings} ref={sliderRef}>
        {SkillsSection.map((route, index) => {
          const { icon, skillTitle, smallDescription } = route;
          return (
            <div
              key={index}
              className={`service-col p-4  transition-opacity duration-500 ${
                isVisible ? "opacity-100" : "opacity-0"
              }`}
            >
              <div className="icon text-4xl text-pink-500 mb-4">{icon}</div>
              <div className="name text-xl font-semibold mb-2">
                {skillTitle}
              </div>
              <div className="single-post-text text-gray-600">
                <p>{smallDescription}</p>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Skills;
